import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { fetchApiConfig } from './api';

const container = document.getElementById('root')!;
const root = createRoot(container);

async function bootstrap(): Promise<void> {
  await fetchApiConfig();

  root.render(
    <App />
  );
}

bootstrap();